// Berechnete Pause/Lücke zwischen zwei aufeinanderfolgenden Zeiteinträgen.
// Es geht um die ZEITLICHE Lücke (Ende des früheren → Start des späteren Eintrags),
// nicht um die explizit erfasste breaks-Tabelle.

// Schwellwert, ab dem eine Lücke als "Pause" angezeigt wird. 15min ist konsistent
// mit der Compliance-/ArbZG-Logik (metricsForDay zählt Lücken >=15min als Pause).
// Eine zentrale Konstante, damit Listen- und Kalender-Ansicht denselben Wert nutzen.
export const MIN_GAP_MINUTES = 15

/**
 * Lücke in Minuten zwischen dem Ende des früheren und dem Start des späteren
 * Eintrags. Generisch — der Aufrufer übergibt jeweils den späteren Start und das
 * frühere Ende (gilt für Liste in desc- wie Grid in asc-Reihenfolge).
 * Gibt null zurück, wenn der frühere Eintrag noch läuft (kein endTime).
 * Negative Werte = Überlappung (sollen NICHT als Pause angezeigt werden).
 */
export function gapMinutes(
  laterStartIso: string,
  earlierEndIso: string | null | undefined,
): number | null {
  if (!earlierEndIso) return null
  const ms = new Date(laterStartIso).getTime() - new Date(earlierEndIso).getTime()
  return Math.round(ms / 60_000)
}
